class FindPdlHelperCtrl {
    /** @ngInject */
    constructor(gaEventsService, ContactTelephone) {
        this.gaEventsService = gaEventsService
        this.ContactTelephone = ContactTelephone
        this.detailState = 'EDF'
        this.displayDetailEDF = false
        this.displayDetailDirectEnergie = false
    }

    $onInit() {
        this.gaEventsService.newEvent('open modal - Comment trouver mon point de livraison ?')
        this.filter = {
            offerType: 'BASE',
            power: 6,
            availablePowers: this.resolve.partnerOffer,
        }
    }

    toggleDetailEDF() {
        this.displayDetailEDF = !this.displayDetailEDF
    }

    toggleDetailDirectEnergie() {
        this.displayDetailDirectEnergie = !this.displayDetailDirectEnergie
    }
}

export default {
    template: require('./findPdlHelper.jade')(),
    controller: FindPdlHelperCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/subscription/modal/findPdlHelper.js